// @flow
import React, { useState, } from 'react';
import { useDispatch } from 'react-redux';
import {
    clearModalContent,
    setModalContent
} from 'src/redux/modules/modalEvent';

import './ClinicianMobileDetails.scss';
import { Typography } from "src/latest/src/components";
import Avatar from 'src/components/base/Avatar/Avatar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeftLong,faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { getMeetingAvailabilityGradient, renderListItems, capitalize  } from './Utils/utils';
import { ClinicianModalTab,FilterKey, PillStyleType, MeetingAvailability} from 'src/latest/src/constants/ClinicianMobileDetailsEnums';

type Props = {
    therapistInfo?: any,
    selectedFilters?: any
}

const TherapistModalContent = ({ therapistInfo,selectedFilters, handleBackClick }) => {
    const [currentTab, setCurrentTab] =useState(ClinicianModalTab.BIO);
    const profileTabs = [
         { key: ClinicianModalTab.BIO },
        ...(therapistInfo?.insurances?.length > 0 ? [{ key: ClinicianModalTab.INSURANCE }] : []),
        { key: ClinicianModalTab.EXPERTISE },
        ...(therapistInfo?.modalities?.length > 0 ?[{ key: ClinicianModalTab.APPROACHES }] : []),
    ];
    const offersInPerson = therapistInfo?.meeting_availability?.some(avail =>
        avail.toLowerCase().includes('in person')
    );
    const insuranceFilterGroup = selectedFilters?.filters?.find(f => f.filter_key === FilterKey.INSURANCE_PLAN);
    const selectedUserInsurance = insuranceFilterGroup?.filter_selection_data?.find(opt => opt.selected)?.label;
    const expertiseFilterGroup = selectedFilters?.filters?.find(f => f.filter_key === FilterKey.SPECIALITY);
    const selectedUserExpertises = expertiseFilterGroup?.filter_selection_data?.filter(opt => opt.selected).map(opt => opt.label) || [];
    const approachFilterGroup = selectedFilters?.filters?.find(f => f.filter_key === FilterKey.MODALITY);
    const selectedUserApproaches = approachFilterGroup?.filter_selection_data?.filter(opt => opt.selected).map(opt => opt.label) || [];

   const getTabDisplayData = (originalList, selectedUserItems, tabType) => {
        // Configuration mapping for limits
        const limitsConfig = {
            expertise: { primaryLimit: 3, secondaryLimit: 4 },
            approaches: { primaryLimit: 1, secondaryLimit: 2 }
        };

        const { primaryLimit, secondaryLimit } = limitsConfig[tabType] || limitsConfig.expertise;

        let primaryList = originalList.slice(0, primaryLimit);
        let secondaryList = originalList.slice(primaryLimit, primaryLimit + secondaryLimit);
        let theRest = originalList.slice(primaryLimit + secondaryLimit);
        let userSelectedMatches = [];

        if (selectedUserItems && selectedUserItems.length > 0) {
            userSelectedMatches = originalList.filter(item => selectedUserItems.includes(item));

            if (userSelectedMatches.length > 0) {
                primaryList = primaryList.filter(item => !selectedUserItems.includes(item));
                secondaryList = secondaryList.filter(item => !selectedUserItems.includes(item));
                theRest = theRest.filter(item => !selectedUserItems.includes(item));
            }
        }

        return {
            userSelectedMatches,
            primaryList,
            secondaryList,
            theRest,
            hasRemainingItems: primaryList.length > 0 || secondaryList.length > 0 || theRest.length > 0
        };
    };

    const renderTabContent = () => {
       const LineBreak = () => <hr className="w-100 my-2 line-break" />;

        switch (currentTab) {
            case ClinicianModalTab.EXPERTISE: {

               const { userSelectedMatches, primaryList, secondaryList, theRest, hasRemainingItems } = getTabDisplayData(therapistInfo?.specialities || [], selectedUserExpertises, ClinicianModalTab.EXPERTISE);

                return (
                    <div className='cards-container d-flex flex-column '>
                        <div className="card-box flex-column align-items-start" >
                            <div className="d-flex flex-wrap gap-2 w-100">
                                {/* Only render selected matches and the line break if they actually exist */}
                                {userSelectedMatches.length > 0 && (
                                    <>
                                        {renderListItems(userSelectedMatches, PillStyleType.USER_SELECTED, ClinicianModalTab.EXPERTISE)}
                                        {hasRemainingItems && <LineBreak />}
                                    </>
                                )}

                                {renderListItems(primaryList, PillStyleType.PRIMARY, ClinicianModalTab.EXPERTISE)}
                                {renderListItems(secondaryList, PillStyleType.SECONDARY, ClinicianModalTab.EXPERTISE)}
                                {renderListItems(theRest, PillStyleType.NORMAL, ClinicianModalTab.EXPERTISE)}
                            </div>
                        </div>
                    </div>
                );
            }

            case ClinicianModalTab.APPROACHES: {

               const { userSelectedMatches, primaryList, secondaryList, theRest, hasRemainingItems } = getTabDisplayData(therapistInfo?.modalities || [], selectedUserApproaches, ClinicianModalTab.APPROACHES);

                return (
                    <div className='cards-container d-flex flex-column '>
                        <div className="card-box flex-column align-items-start">
                            <div className="d-flex flex-wrap gap-2 w-100">
                                {/* Only render selected matches and the line break if they actually exist Same as Experties */}
                                {userSelectedMatches.length > 0 && (
                                    <>
                                        {renderListItems(userSelectedMatches, PillStyleType.USER_SELECTED, ClinicianModalTab.APPROACHES)}
                                         {hasRemainingItems && <LineBreak />}
                                    </>
                                )}

                                {renderListItems(primaryList, PillStyleType.PRIMARY, ClinicianModalTab.APPROACHES)}
                                {renderListItems(secondaryList, PillStyleType.SECONDARY, ClinicianModalTab.APPROACHES)}
                                {renderListItems(theRest, PillStyleType.NORMAL, ClinicianModalTab.APPROACHES)}
                            </div>
                        </div>
                    </div>
                );
            }

            case ClinicianModalTab.INSURANCE: {
                const originalInsurances = therapistInfo?.insurances || [];
                let userSelected = [];
                let theRest = originalInsurances;

                // If filter exists and matches, IF not then plian list will be shown
                if (selectedUserInsurance && originalInsurances.includes(selectedUserInsurance)) {
                    userSelected = [selectedUserInsurance];
                    theRest = originalInsurances.filter(item => item !== selectedUserInsurance);
                }

                return (
                    <div className='cards-container d-flex flex-column '>
                        <div className="card-box flex-column align-items-start" >
                            <div className="d-flex flex-wrap gap-2 w-100">
                                {userSelected.length > 0 && (
                                    <>
                                        {renderListItems(userSelected, PillStyleType.USER_SELECTED, ClinicianModalTab.INSURANCE)}
                                        {theRest.length > 0 && <LineBreak />}
                                    </>
                                )}
                                {renderListItems(theRest, PillStyleType.NORMAL, ClinicianModalTab.INSURANCE)}
                            </div>
                        </div>
                    </div>
                );
            }

            case ClinicianModalTab.BIO:
            default:
                return (
                    <div className='cards-container d-flex flex-column'>


                        <div className="mobile-availability card-box">
                            <div className="card-label">Meeting<br/>Availability</div>
                            <div className="card-value d-flex align-items-center">
                                {therapistInfo?.meeting_availability?.length > 0 ? (
                                    <div className='d-inline-flex align-items-center'>
                                        <div className="icon-wrapper">
                                            {getMeetingAvailabilityGradient(therapistInfo.meeting_availability[0], therapistInfo).icons}
                                        </div>
                                        <Typography className='ms-2 m-0 fw-medium' variant="size-14">
                                            {getMeetingAvailabilityGradient(therapistInfo.meeting_availability[0], therapistInfo).label === MeetingAvailability.BOTH
                                                ? MeetingAvailability.DISPLAY_BOTH
                                                : getMeetingAvailabilityGradient(therapistInfo.meeting_availability[0], therapistInfo).label === MeetingAvailability.TELETHERAPY
                                                ? MeetingAvailability.DISPLAY_ONLINE
                                                : getMeetingAvailabilityGradient(therapistInfo.meeting_availability[0], therapistInfo).label}
                                        </Typography>
                                    </div>
                                ) : (
                                    'N/A'
                                )}
                            </div>
                        </div>

                        {offersInPerson && (
                            <div className="mobile-office-location card-box">
                                <div className="card-label">Office Address</div>
                                <div className="card-value fw-medium">
                                    {therapistInfo?.therapy_location?.length > 0
                                        ? therapistInfo.therapy_location[0]
                                        : 'N/A'}
                                </div>
                            </div>
                        )}

                       {/* TOGGLE CONDITION: INSURANCE MATCH CARD vs CASH-PAY INTAKE FEE */}
                        {selectedUserInsurance && therapistInfo?.insurances?.includes(selectedUserInsurance) ? (
                            <div className="mobile-insurance card-box">
                                <div className="card-label">Insurance</div>
                                <div className="card-value fw-medium">
                                    {selectedUserInsurance} Accepted
                                </div>
                            </div>
                        ) : (
                            <div className="mobile-intake-fee card-box">
                                <div className="card-label">Cash-Pay<br/>Intake Fee</div>
                                <div className="card-value fw-medium">
                                    {therapistInfo?.session_fee ? `$${therapistInfo.session_fee}` : 'N/A'}
                                </div>
                            </div>
                        )}

                        <div className="mobile-languages card-box">
                            <div className="card-label">Languages</div>
                            <div className="card-value fw-medium">
                                {therapistInfo?.languages?.length > 0
                                    ? therapistInfo.languages.join(', ')
                                    : 'N/A'}
                            </div>
                        </div>

                         {therapistInfo?.bio && (
                           <div className="mobile-bio card-box">
                                <div className="card-value bio-scroll">
                                     <Typography variant="size-14" color="color-2">
                                        {therapistInfo.bio}
                                    </Typography>
                                </div>
                            </div>
                        )}

                    </div>
                );
        }
    };

    return (
        <div className='therapist-detail-mobile'>
            <div className='therapist-card'>
                <div className='Avatar-Clinician-model'>
                    <Avatar
                        photoUrl={therapistInfo?.profile_picture}
                        fullName={therapistInfo?.therapist_name}
                        size='64px'
                    />
                </div>
                <div className='profile-info ms-3 text-start'>
                    <div className='d-flex align-items-baseline flex-wrap gap-2'>
                        <Typography weight='bold' variant='size-18' color='color-2'
                        className="m-0 mobile-therapistname">
                            {therapistInfo?.therapist_name},
                        </Typography>
                        {therapistInfo?.therapist_credentials && (
                            <Typography  weight='bold' color='color-2' variant='size-18'
                            className="mobile-credentials m-0">
                                {therapistInfo.therapist_credentials}
                            </Typography>
                        )}
                    </div>
                    <div className='mobile-provider-type mt-1'>
                        <Typography color='color-4' variant='size-14'>
                            {therapistInfo?.provider_type }
                        </Typography>
                    </div>
                </div>
            </div>

            <div className="links">
                {profileTabs.map((item) => (
                   <div
                       key={item.key}
                       className={`tab-link ${currentTab === item.key ? 'active-tab' : ''}`}
                       onClick={() => setCurrentTab(item.key)}
                    >
                        <Typography
                            color={currentTab ===  item.key ? "color-2" : "color-4"}
                            variant="size-14"
                            weight="bold"
                        >
                            {capitalize(item.key)}
                        </Typography>
                    </div>
                ))}
            </div>

            <div className="modal-tab-content-area">
                {renderTabContent()}
            </div>

            <div className='back-btn'>
                <button
                    className='backAvailability btn btn-transparent'
                    onClick={handleBackClick}
                >
                    <FontAwesomeIcon icon={faArrowLeftLong} className='arrow-left' size='sm' />
                    Back to Availability
                </button>
            </div>
        </div>
    );
};

const ClinicianMobileDetails = ({ therapistInfo,selectedFilters }: Props): React.ReactElement<any> => {
    const dispatch = useDispatch();

    const handleClick = () => {
        dispatch(
            setModalContent({
                modalContent: <TherapistModalContent
                                therapistInfo={therapistInfo}
                                selectedFilters={selectedFilters}
                                handleBackClick={() => dispatch(clearModalContent())}
                              />,
                isWithCancelButton: false,
                size: 'lg',
                title: 'Clinician Details',
                className: 'therapist-detail-mobile'
            })
        );
    };

    return (
        <div className="button-arrow">
            <button
                onClick={handleClick}
                className="viewdetails btn  btn-transparent "
            >
                View Details
            </button>

            <FontAwesomeIcon
                icon={faArrowRight}
                className="arrow-right p-1"
                size="xs"
            />
        </div>
    );
};

export default ClinicianMobileDetails;
